/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const tableData = {
    gridOptions: {
      pagination: true,
      rowHeight: 50,
      defaultColDef: {
        resizable: true,
        sortable: true,
        filter: true,
        floatingFilter: true,
        unSortIcon: true,
      },
    },
    columnDefs: [
      {
        type: "default",
        compProps: {
          headerName: "Full Name",
          field: "name",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "Email",
          field: "email",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "User Type",
          field: "type",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "default",
        compProps: {
          headerName: "Message",
          field: "message",
          filter: "agTextColumnFilter",
          editable: false,
          minWidth: 110,
        },
        valueStyle: {
          color: "#1a4677",
        },
      },
      {
        type: "icon",
        iconOnly: false,
        compProps: {
          headerName: "Status",
          field: "status",
          filter: "agTextColumnFilter",
          minWidth: 190,
        },
        typeProps: [
          {
            name: "primitive-dot",
            color: "green",
            value: "Registered",
            type: "octicon",
            style: { marginTop: 2 },
            size: 15,
          },
          {
            name: "primitive-dot",
            color: "red",
            value: "Pending",
            type: "octicon",
            style: { marginTop: 2 },
            size: 15,
          },
          // {
          //   name: "primitive-dot",
          //   color: "orange",
          //   value: "Unknown",
          //   type: "octicon",
          //   style: { marginTop: 2 },
          //   size: 15,
          // },
        ],
        valueStyle: { color: "#1a4677" },
      },
      {
        type: "button",
        compProps: {
          headerName: "Action",
          field: "more",
          resizable: false,
          suppressSizeToFit: true,
          pinned: "right",
          width: 100,
        },
        typeProps: [
          {
            title: "Register",
            value: "Register",
            type: "outline",
            disabled:true,
            buttonStyle: {
              width: 70,
              height: 20,
              borderColor: "#1a4677",
            },
            titleStyle: {
              fontSize: 12,
              color: "#1a4677",
            },
          },
          // {
          //   title: "Action Required",
          //   value: "action-required",
          //   type: "outline",
          //   buttonStyle: {
          //     width: 70,
          //     height: 30,
          //     borderColor: "#1a4677",
          //   },
          //   titleStyle: {
          //     fontSize: 12,
          //     color: "#1a4677",
          //   },
          // },
        ],
        valueStyle: {
          color: "#1a4677",
        },
      },
    ],
    rowData: [
      {
        name: "Mahendra C",
        email: "mahendra@vlinder.io",
        type: "Individual",
        status: "Pending",
        message: "test message",
        more: "Register"
      },
    ],
  };